import * as Icons from "lucide-react";

export function Icon({ name, className, ...props }) {
    const C = Icons[name] || Icons.Sparkles;
    return <C className={className} {...props} />;
}
